<script lang="ts">
    import Icons from "./icons.svelte";
    import type {IconTypes} from './icons.svelte';

    export let handleClick = () => {}
    export let icon:IconTypes = 'carret up';
    export let disabled:boolean = false;
    
</script>



<button on:click={handleClick} disabled={disabled}>
    <Icons icon={icon} color={disabled ? 'disabled' : 'text'}></Icons>
</button>


<style>
    button {
        border: unset;
        background-color: unset;
        padding: 0.75rem;
        border-radius: 50%;
        line-height: 0;
        background-color: var(--background);
        margin: 0;
    }
    button:hover {
        background-color: var(--background-secondary);
    }
    button:active {
        background-color: var(--background-offset);
    }
    button:disabled {
        background-color: unset;
        cursor: not-allowed;
    }

</style>